"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keys = exports.filterMap = exports.exhaustivenessCheck = exports.sortDictByKey = void 0;
var lodash_1 = require("lodash");
var sortDictByKey = function (dict) { return (0, lodash_1.fromPairs)((0, lodash_1.sortBy)((0, lodash_1.toPairs)(dict))); };
exports.sortDictByKey = sortDictByKey;
var exhaustivenessCheck = function (_x) {
    throw new Error('Exhaustiveness check failed');
};
exports.exhaustivenessCheck = exhaustivenessCheck;
function filterMap(input, iteratee) {
    return (0, lodash_1.compact)((0, lodash_1.map)(input, iteratee));
}
exports.filterMap = filterMap;
// version of Object.keys that returns the expected key type
function keys(object) {
    return (object ? Object.keys(object) : []);
}
exports.keys = keys;
